import React, { useContext, useState, useRef, useEffect } from 'react'
import { useHistory, Link, useLocation } from 'react-router-dom';
import { getAuth, signOut } from 'firebase/auth';
import { ChessSocialContext } from "../util/ChessSocialContext";
import { usePremium } from '../util/PremiumFilter'; // Import premium context
import ChesssLogo from "../images/chessslogo.png";
// Import Firebase Firestore functions
import { db } from '../util/firebase';
import { collection, query, where, getDocs, orderBy, limit, startsWith, doc, getDoc, addDoc } from 'firebase/firestore';
// Import firestore for feedback functionality
import { firestore } from '../firebase';
// Import TAGS from constants
import { TAGS, allowedEcoGroups } from '../util/constants';
import mansalva from '../images/Mansalva/Mansalva-Regular.ttf';
import { sortUsersByPremium } from '../util/userUtils';

import GrayCrown from '../images/CrownDimGray.png';
import GoldCrown from '../images/CrownGold.png';

import GrayBrilliantIcon from '../images/FooterIcons/Brilliance3.png';
import BlueBrilliantIcon from '../images/FooterIcons/Brilliance2.png';

import { makeStyles } from "@material-ui/core/styles";
// Redux stuff
import { connect } from 'react-redux';

// Add a style block to define the font-face
const MansalvaFontStyle = () => {
  return (
    <style>
      {`
        @font-face {
          font-family: 'Mansalva';
          src: url(${mansalva}) format('truetype');
          font-weight: normal;
          font-style: normal;
          font-display: swap;
        }
        
        /* Nav tooltip styles */
        .nav-tooltip {
          visibility: hidden;
          position: fixed; /* Use fixed instead of absolute to escape container boundaries */
          background-color: black;
          color: gold;
          text-align: center;
          padding: 6px 12px;
          border-radius: 6px;
          z-index: 1500; /* Higher z-index to ensure it appears above everything */
          white-space: nowrap;
          border: 2px solid gold;
          font-weight: bold;
          font-size: 14px;
          box-shadow: 0 0 5px rgba(255, 215, 0, 0.3);
          pointer-events: none;
          opacity: 0;
          transition: opacity 0.2s ease;
        }
        
        /* Different tooltip positions based on available space */
        .nav-button:hover .nav-tooltip {
          visibility: visible;
          opacity: 1;
        }
        
        /* Custom styling for Analyze & Share tooltip */
        #tooltip-analyze {
          padding: 8px 14px;
          color: #ff0050;  
          border: 2px solid #ff0050;
        }
        
        /* Add hover styling for Analyze & Share plus icon */
        .pink-hover {
          transition: border-color 0.2s ease, color 0.2s ease;
        }
        
        .pink-hover:hover {
          border-color: #ff0050 !important;
        }
        
        .pink-hover .fa-square-plus {
          transition: color 0.2s ease;
        }
        
        .pink-hover span {
          transition: color 0.2s ease;
        }
        
        .pink-hover:hover .fa-square-plus {
          color: #ff0050 !important;
        }
        
        /* When Analyze & Share is not active, change text color on hover */
        .pink-hover:hover span {
          color: #ff0050 !important;
        }
        
        /* Custom styling for Premium tooltip */
        #tooltip-premium {
          padding: 8px 14px;
        }

        /* Custom styling for Play Chess tooltip */
        #tooltip-play {
          padding: 8px 14px;
          color: #58b047;  
          border: 2px solid #58b047;
        }
        
        /* Custom styling for engine control panel tooltips */
        .engine-panel-tooltip {
          visibility: hidden;
          background-color: black;
          color: white;
          text-align: center;
          padding: 4px 8px;
          border-radius: 4px;
          position: absolute;
          bottom: 115%;
          left: 50%;
          transform: translateX(-50%);
          white-space: nowrap;
          border: 1px solid #555;
          font-weight: bold;
          font-size: 12px;
          box-shadow: 0 0 5px rgba(0, 0, 0, 0.5);
          pointer-events: none;
          opacity: 0;
          transition: opacity 0.2s ease;
          z-index: 1200;
        }
        
        /* Show tooltip on hover */
        .engine-panel-btn:hover .engine-panel-tooltip {
          visibility: visible;
          opacity: 1;
        }
      `}
    </style>
  );
};

// CSS for global scrollbar styling
const GlobalScrollbarStyle = () => {
  return (
    <style>
      {`
        /* Global scrollbar styling */
        .custom-scrollbar::-webkit-scrollbar {
          width: 6px;
        }
        
        .custom-scrollbar::-webkit-scrollbar-track {
          background: #333;
          border-radius: 3px;
        }
        
        .custom-scrollbar::-webkit-scrollbar-thumb {
          background-color: gold;
          border-radius: 3px;
          border: 1px solid #333;
        }
        
        /* Firefox scrollbar */
        .custom-scrollbar {
          scrollbar-width: thin;
          scrollbar-color: gold #333;
        }
      `}
    </style>
  );
};

const Sidebar = (props) => {
  const history = useHistory();
  const location = useLocation();
  const {
    setActiveTab,
    activeTab,
    showStockfish,
    setShowStockfish,
    showStockfishEval,
    setShowStockfishEval,
    showStockfishPanel,
    setShowStockfishPanel,
    isSidebarCollapsed,
    setIsSidebarCollapsed,
    showEmoji,
    setShowEmoji,
    showStockfishIcons,
    setShowStockfishIcons,
    showArrows,
    setShowArrows,
    user
  } = useContext(ChessSocialContext);
  // Use the premium context
  const { isPremiumUser, togglePremiumStatus, premiumFeatures, renderUserWithBadge, PREMIUM_TIERS } = usePremium();

  // Initialize with a default collapsed state
  const [isCollapsed, setIsCollapsed] = useState(true);

  // Add new state for search overlay
  const [showSearch, setShowSearch] = useState(false);

  // Add state for crown hover
  const [isHoveringCrown, setIsHoveringCrown] = useState(false);

  // Add these state variables at the top of the Sidebar component
  const [searchTerm, setSearchTerm] = useState("");
  const [isSearchFocused, setIsSearchFocused] = useState(false);
  // Add state for active search tab (User or Chess)
  const [activeSearchTab, setActiveSearchTab] = useState("User");
  const [searchResults, setSearchResults] = useState({
    users: [],
    followedUsers: [], // Add separate array for followed users
    tags: [],
    openings: [],
    endgames: []
  });
  const [isLoading, setIsLoading] = useState(false);
  const [initialSearchLoaded, setInitialSearchLoaded] = useState(false);
  const searchInputRef = useRef(null);

  // Add feedback state variables
  const [showFeedbackForm, setShowFeedbackForm] = useState(false);
  const [feedbackMessage, setFeedbackMessage] = useState('');
  const [isSubmittingFeedback, setIsSubmittingFeedback] = useState(false);
  const [feedbackRateLimit, setFeedbackRateLimit] = useState({ count: 0, lastReset: Date.now() });

  // Add notification status state
  const [hasUnreadNotifications, setHasUnreadNotifications] = useState(false);

  const sidebarWidth = isCollapsed ? "75px" : "200px";

  // Check for unread notifications - efficient single query using targetUser field
  const checkNotifications = async () => {
    // Get authenticated user handle from props or context
    const authenticatedUserHandle = props?.user?.credentials?.handle || user?.credentials?.handle;
    
    if (!authenticatedUserHandle) return;

    try {
      // Single efficient query for any unread notifications for this user
      const unreadQuery = query(
        collection(firestore, "notifications"),
        where("status", "==", "unread"),
        where("targetUser", "==", authenticatedUserHandle),
        limit(1) // Only need to know if ANY exist
      );
      
      const snapshot = await getDocs(unreadQuery);
      setHasUnreadNotifications(!snapshot.empty);
      
    } catch (error) {
      // console.error("Error checking notifications:", error);
    }
  };

  // Clear notification status when user visits interaction page
  const clearNotificationStatus = () => {
    setHasUnreadNotifications(false);
  };

  // Check notifications on app load and focus events
  useEffect(() => {
    const authenticatedUserHandle = props?.user?.credentials?.handle || user?.credentials?.handle;
    
    if (authenticatedUserHandle) {
      // Check immediately on load
      checkNotifications();

      // Check when user returns to tab/app
      const handleFocus = () => checkNotifications();
      const handleVisibilityChange = () => {
        if (!document.hidden) checkNotifications();
      };

      window.addEventListener('focus', handleFocus);
      document.addEventListener('visibilitychange', handleVisibilityChange);

      return () => {
        window.removeEventListener('focus', handleFocus);
        document.removeEventListener('visibilitychange', handleVisibilityChange);
      };
    }
  }, [props?.user?.credentials?.handle, user?.credentials?.handle]);

  // Clear notifications when visiting interaction page
  useEffect(() => {
    if (location.pathname === '/interaction') {
      clearNotificationStatus();
    }
  }, [location.pathname]);

  // Initialize the sidebar state - prefer localStorage if it exists, otherwise default to collapsed
  useEffect(() => {
    const savedState = localStorage.getItem('isSidebarCollapsed');

    if (savedState !== null) {
      // If there's a saved preference, use it
      const parsedState = JSON.parse(savedState);
      setIsCollapsed(parsedState);
      setIsSidebarCollapsed(parsedState);
    } else {
      // If no saved preference, default to collapsed 
      setIsCollapsed(true);
      setIsSidebarCollapsed(true);
      localStorage.setItem('isSidebarCollapsed', JSON.stringify(true));
    }
  }, []);

  // After mounting, check current auth user and preload followed users
  useEffect(() => {
    const checkAuth = async () => {
      // Try to get authenticated user from Redux or context
      let authUser = props?.user || user;

      // If we have an authenticated user, preload followed users for later use
      if (authUser?.credentials?.handle) {
        
        const followedUsers = await fetchFollowedUsers();
        if (followedUsers.length > 0) {
          setSearchResults(prevResults => ({
            ...prevResults,
            followedUsers
          }));
          setInitialSearchLoaded(true);
        }
      }
    };

    checkAuth();
  }, [props?.user, user]);

  // Handle changes from context
  useEffect(() => {
    setIsCollapsed(isSidebarCollapsed);
  }, [isSidebarCollapsed]);

  // Create a handler for tab changes that won't affect collapse state
  const handleTabChange = (tab) => {
    // Special handling for Premium tab based on user's premium status
    if (tab === "Premium") {
      // If user is premium, redirect to premium portal instead
      if (isPremiumUser) {
        setActiveTab("PremiumVerified");
        return;
      }
      // For non-premium users, proceed to regular Premium sales page
    }
    
    // Clear notification indicator when clicking Interactions
    if (tab === "interaction") {
      clearNotificationStatus();
    }
    
    setActiveTab(tab);
  };

  const handleLogout = async () => {
    try {
      const auth = getAuth();
      await signOut(auth);
      
      // ✅ Clear Authentication Tokens
      localStorage.removeItem('FBIdToken'); // Firebase authentication token
      localStorage.removeItem('LichessIdToken'); // Lichess OAuth token
      localStorage.removeItem('accessToken'); // Any additional access tokens
      localStorage.removeItem('refreshToken'); // Any refresh tokens
      
      // ✅ Clear Session Cache/Flags
      localStorage.removeItem('welcomeModalShown'); // Session-specific modal flag
      localStorage.removeItem('sessionStartTime'); // Session timing data
      localStorage.removeItem('lastActiveTab'); // Current session tab state
      localStorage.removeItem('currentGameId'); // In-progress game session
      localStorage.removeItem('lichessOauthConfig'); // OAuth configuration data
      localStorage.removeItem('selectedTabFilter'); // Current session filter state
      
      // ✅ Clear Cached User Data (must be fetched again on login)
      localStorage.removeItem('userProfile'); // Cached user profile data
      localStorage.removeItem('userEmail'); // Cached email
      localStorage.removeItem('userSettings'); // Server-synced user settings
      
      // ✅ Clear Context/App State Sync Flags
      localStorage.removeItem('syncStatus'); // Data synchronization status
      localStorage.removeItem('firebaseInit'); // Firebase initialization flags
      localStorage.removeItem('authRedirectPending'); // Authentication redirect state
      
      // ✅ Clear Temporary Session Data
      localStorage.removeItem('analysisImportPGN'); // Temporary analysis data
      localStorage.removeItem('currentPositionFen'); // Current game position
      localStorage.removeItem('portalSeenGameIds'); // Session-specific game tracking
      localStorage.removeItem('hiddenSpamGames'); // Admin session data
      localStorage.removeItem('hiddenReportedComments'); // Admin session data
      
      // 🛑 PRESERVE User Preferences (DO NOT REMOVE):
      // - boardTheme: User's preferred board theme
      // - customColors: Custom board color settings
      // - showCoordinates: Board coordinate display preference
      // - showLegalMoves: Legal move highlighting preference
      // - hideLiveChat: Chat visibility preference
      // - isSidebarCollapsed: Sidebar state preference
      // - stockfishUiVersion: Stockfish UI preferences
      // - stockfishArrowSetting: Arrow display preferences
      // - stockfishAnalysisDepth: Analysis depth preferences
      // - stockfishRecalcThreshold: Recalculation threshold preferences
      // - viewGame_showStockfish: ViewGame Stockfish preference
      // - viewGame_showStockfishEval: ViewGame eval bar preference
      // - viewGame_showArrows: ViewGame arrows preference
      // - viewGame_showStockfishIcons: ViewGame icons preference
      // - addGame_showStockfish: AddGame Stockfish preference
      // - addGame_showStockfishEval: AddGame eval bar preference
      // - addGame_showStockfishIcons: AddGame icons preference
      // - showStockfish: General Stockfish preference
      // - showStockfishIcons: General Stockfish icons preference
      // - boardSize: User's preferred board size
      // - chessMenuCollapsed: Chess menu state preference
      // - chessChatCollapsed: Chess chat state preference
      // - isOpponentHidden: Opponent visibility preference
      // - preferredDifficulty: User's preferred difficulty setting
      // - gameMode: User's preferred game mode
      // - engineDifficulty: User's preferred engine difficulty
      // - showUndoButton: Undo button visibility preference
      // - portalDifficulty: Portal difficulty filter preference
      
      // Redirect to login page
      history.push('/login');
    } catch (error) {
      // console.error('Error logging out:', error);
    }
  };

  // Handle opening the search overlay immediately load followed users
  const handleSearchIconClick = () => {
    // First expand the sidebar
    setIsCollapsed(false); // Force sidebar to expand
    setIsSidebarCollapsed(false); // Make sure the context is updated too
    // Add a short delay to ensure sidebar width change is processed before opening search
    setTimeout(() => {
      setShowSearch(true); // Show search overlay after sidebar expansion is complete
      localStorage.setItem('isSidebarCollapsed', JSON.stringify(false)); // Persist expanded state to local storage

      // Immediately preload followed users when opening search
      handleSearchInputClick();
    }, 50); // Small delay for the width transition to take effect
  };

  // Generate dynamic openings from allowedEcoGroups
  const dynamicOpenings = Object.entries(allowedEcoGroups).map(([name, codes]) => ({
    id: name.toLowerCase().replace(/[^a-z0-9]/g, '-'),
    name: name,
    description: `ECO codes: ${codes[0]}${codes.length > 1 ? '-' + codes[codes.length - 1] : ''}`,
    codes: codes
  }));

  // Handler for when a user without premium access clicks the Stockfish button
  const handlePremiumRequired = () => {
    // Navigate to the premium page
    handleTabChange("Premium");
  };

  // Update fetchFollowedUsers function to better handle authentication
  const fetchFollowedUsers = async () => {
    try {
      setIsLoading(true);

      // First try to get the authenticated user handle from Redux state (props)
      const authUser = props?.user || {};
      let currentUserHandle = authUser?.credentials?.handle;

      // If not found in props, try from context
      if (!currentUserHandle && user?.credentials) {
        currentUserHandle = user.credentials.handle;
      }

      

      // If we still don't have a handle, try to get it from localStorage
      if (!currentUserHandle) {
        // Check if Firebase token exists
        const token = localStorage.getItem('FBIdToken');
        if (token) {
          try {
            // If token exists, try to decode and use it to get the user data
            
            const userResponse = await fetch(`${process.env.REACT_APP_API_BASE_URL || 'https://api-v7poaqj4ga-uc.a.run.app'}/user`, {
              headers: {
                'Authorization': token
              }
            });
            if (userResponse.ok) {
              const userData = await userResponse.json();
              if (userData.credentials && userData.credentials.handle) {
                currentUserHandle = userData.credentials.handle;
                
              }
            }
          } catch (error) {
            // console.error("Error fetching user with token:", error);
          }
        }
      }

      if (!currentUserHandle) {
        
        setIsLoading(false);
        return [];
      }

      // Reference to the current user's document
      const userRef = doc(db, "users", currentUserHandle);
      const userSnap = await getDoc(userRef);

      if (!userSnap.exists()) {
        
        setIsLoading(false);
        return [];
      }

      const userData = userSnap.data();
      

      // Get the following array from the user's document
      const followingList = userData.following || [];

      

      if (followingList.length === 0) {
        setIsLoading(false);
        return [];
      }

      // Get details for each followed user
      const followedUsers = [];

      try {
        // Create a batch query to get all followed users at once
        // Note: Firestore "in" query limited to 10 values, so we may need to chunk for larger lists
        if (followingList.length <= 10) {
          const usersRef = collection(db, "users");
          const q = query(usersRef, where("handle", "in", followingList));
          const querySnapshot = await getDocs(q);

          querySnapshot.forEach((doc) => {
            const userData = doc.data();
            followedUsers.push({
              id: doc.id,
              name: userData.handle,
              isPremium: userData.isPremium || false,
              premium: userData.premium !== undefined ? userData.premium : (userData.isPremium ? 1 : 0), // Add numeric premium level
              imageUrl: userData.imageUrl || null,
              isFollowed: true
            });
          });
        } else {
          // Handle more than 10 following users by chunking the requests
          for (let i = 0; i < followingList.length; i += 10) {
            const chunk = followingList.slice(i, i + 10);
            const usersRef = collection(db, "users");
            const q = query(usersRef, where("handle", "in", chunk));
            const querySnapshot = await getDocs(q);

            querySnapshot.forEach((doc) => {
              const userData = doc.data();
              followedUsers.push({
                id: doc.id,
                name: userData.handle,
                isPremium: userData.isPremium || false,
                premium: userData.premium !== undefined ? userData.premium : (userData.isPremium ? 1 : 0), // Add numeric premium level
                imageUrl: userData.imageUrl || null,
                isFollowed: true
              });
            });
          }
        }
      } catch (error) {
        // console.error("Error in batch query:", error);

        // Fallback to individual queries if batch query fails
        
        for (const followedHandle of followingList) {
          try {
            const usersQuery = query(
              collection(db, "users"),
              where("handle", "==", followedHandle)
            );

            const userQuerySnap = await getDocs(usersQuery);

            if (!userQuerySnap.empty) {
              const userData = userQuerySnap.docs[0].data();
              followedUsers.push({
                id: userQuerySnap.docs[0].id,
                name: userData.handle,
                isPremium: userData.isPremium || false,
                premium: userData.premium !== undefined ? userData.premium : (userData.isPremium ? 1 : 0), // Add numeric premium level
                imageUrl: userData.imageUrl || null,
                isFollowed: true
              });
            }
          } catch (e) {
            // console.error("Error fetching individual user:", followedHandle, e);
          }
        }
      }

      
      setIsLoading(false);
      return followedUsers;
    } catch (error) {
      // console.error("Error fetching followed users:", error);
      setIsLoading(false);
      return [];
    }
  };

  // Update the handleSearchInputClick function
  const handleSearchInputClick = () => {
    setIsSearchFocused(true);
    if (searchInputRef.current) {
      searchInputRef.current.focus();
    }

    // If we haven't already loaded followed users, do it now
    if (!initialSearchLoaded) {
      // Load followed users and dynamic openings when search is focused
      const loadInitialData = async () => {
        const followedUsers = await fetchFollowedUsers();
        
        // Sort followed users by premium status
        const sortedFollowedUsers = sortUsersByPremium(followedUsers);
        
        // Get initial tags (first 5)
        const initialTags = Object.entries(TAGS).slice(0, 5).map(([key, tagData]) => ({
          id: key,
          name: tagData.label,
          color: tagData.color,
          background: tagData.background,
          className: tagData.className,
          sisterGroup: tagData.sisterGroup
        }));

        setSearchResults({
          users: [],
          followedUsers: sortedFollowedUsers.slice(0, 10),
          tags: initialTags, // Show initial tags even with empty search
          openings: dynamicOpenings.slice(0, 5) // Limit to 5 openings
        });

        setInitialSearchLoaded(true);
      };

      loadInitialData();
    } else {
      // Just update with dynamic openings and tags since we already have followed users
      const initialTags = Object.entries(TAGS).slice(0, 5).map(([key, tagData]) => ({
        id: key,
        name: tagData.label,
        color: tagData.color,
        background: tagData.background,
        className: tagData.className,
        sisterGroup: tagData.sisterGroup
      }));
      
      setSearchResults(prevResults => ({
        ...prevResults,
        tags: initialTags,
        openings: dynamicOpenings.slice(0, 5) // Limit to 5 openings
      }));
    }
  };

  // Helper function to render username with badge from search results
  const renderSearchResultUser = (user) => {
    // If user is a simple string, just render with username
    if (typeof user === 'string') {
      return renderUserWithBadge(user);
    }
    
    // If user is an object, extract name and convert isPremium to premium tier
    if (user && typeof user === 'object') {
      const username = user.name || user.handle || '';
      
      // Convert isPremium boolean to premium number (0-3)
      // If user has premium field directly, use it
      // Otherwise, convert isPremium boolean to BRONZE tier (1)
      let premiumTier = PREMIUM_TIERS.NONE;
      if (user.premium !== undefined) {
        premiumTier = user.premium; // Use existing premium value if present
      } else if (user.isPremium === true) {
        premiumTier = PREMIUM_TIERS.BRONZE; // Convert boolean to BRONZE tier
      }
      
      return renderUserWithBadge(username, premiumTier);
    }
    
    // Fallback
    return null;
  }

  // Real search function to query Firebase for users and filter tags
  const handleSearch = async (term) => {
    if (!term.trim()) {
      // Even when the search term is empty, we'll show followed users and dynamic openings
      // Use existing followed users if we already loaded them
      if (!initialSearchLoaded) {
        const followedUsers = await fetchFollowedUsers();
        
        // Sort followed users by premium status
        const sortedFollowedUsers = sortUsersByPremium(followedUsers);
        
        // Get initial tags (first 5)
        const initialTags = Object.entries(TAGS).slice(0, 5).map(([key, tagData]) => ({
          id: key,
          name: tagData.label,
          color: tagData.color,
          background: tagData.background,
          className: tagData.className,
          sisterGroup: tagData.sisterGroup
        }));

        setSearchResults({
          users: [],
          followedUsers: sortedFollowedUsers.slice(0, 10),
          tags: initialTags, // Show initial tags even with empty search
          openings: dynamicOpenings.slice(0, 5) // Limit to 5 openings
        });

        setInitialSearchLoaded(true);
      } else {
        // Keep existing tags and openings for empty search
        setSearchResults(prevResults => ({
          ...prevResults,
          users: []
        }));
      }
      return;
    }

    setIsLoading(true);

    try {
      // Use existing followed users if we already loaded them
      let followedUsers = searchResults.followedUsers;

      // If we don't have followed users yet, fetch them
      if (followedUsers.length === 0 && !initialSearchLoaded) {
        followedUsers = await fetchFollowedUsers();
        setInitialSearchLoaded(true);
      }

      const followedHandles = followedUsers.map(user => user.name.toLowerCase());

      // Query for users where handle contains the search term
      const usersRef = collection(db, "users");

      // Get a larger set of users and filter client-side for case-insensitive matching
      const userSnapshot = await getDocs(collection(db, "users"));
      const userResults = [];

      // Filter the results client-side using case-insensitive matching
      userSnapshot.forEach((doc) => {
        const userData = doc.data();
        // Check if the handle field exists and contains the search term (case-insensitive)
        if (userData.handle &&
          userData.handle.toLowerCase().includes(term.toLowerCase())) {

          // Check if the user is already in followed users
          const isFollowed = followedHandles.includes(userData.handle.toLowerCase());

          // Skip if the user is already in followed users - we'll display them in the followed section
          if (isFollowed) {
            return;
          }

          userResults.push({
            id: doc.id,
            name: userData.handle, // Use the original handle with its original casing
            isPremium: userData.isPremium || false, // Add premium status
            premium: userData.premium !== undefined ? userData.premium : (userData.isPremium ? 1 : 0), // Add numeric premium level
            imageUrl: userData.imageUrl || null,
            isFollowed: false // Mark as not followed
          });
        }
      });

      // Filter followed users by search term
      const filteredFollowedUsers = followedUsers.filter(user =>
        user.name.toLowerCase().includes(term.toLowerCase())
      ).slice(0, 10); // Limit to maximum 10 followed users

      // Calculate how many non-followed users we can show while keeping total users at max 10
      const maxNonFollowedUsers = Math.max(0, 10 - filteredFollowedUsers.length);
      
      // Limit non-followed user results based on remaining space
      const limitedUserResults = userResults.slice(0, maxNonFollowedUsers);

      // Sort the results by premium status
      const sortedUserResults = sortUsersByPremium(limitedUserResults);

      // Filter tags from constants.js
      const tagResults = [];
      const lowerCaseTerm = term.toLowerCase();

      Object.entries(TAGS).forEach(([key, tagData]) => {
        if (key.toLowerCase().includes(lowerCaseTerm) ||
          tagData.label.toLowerCase().includes(lowerCaseTerm)) {
          tagResults.push({
            id: key,
            name: tagData.label,
            color: tagData.color,
            background: tagData.background,
            className: tagData.className,
            sisterGroup: tagData.sisterGroup
          });
        }
      });

      // Filter dynamic openings
      const openingResults = dynamicOpenings.filter(opening =>
        opening.name.toLowerCase().includes(lowerCaseTerm) ||
        (opening.description && opening.description.toLowerCase().includes(lowerCaseTerm)) ||
        (opening.codes && opening.codes.some(code => code.toLowerCase().includes(lowerCaseTerm)))
      );

      setSearchResults({
        users: sortedUserResults,
        followedUsers: sortUsersByPremium(filteredFollowedUsers),
        tags: tagResults.slice(0, 5), // Limit to 5 tags
        openings: openingResults.slice(0, 5) // Limit to 5 openings
      });
    } catch (error) {
      // console.error("Error searching:", error);
    } finally {
      setIsLoading(false);
    }
  };

  // Debounce search input
  useEffect(() => {
    if (!isSearchFocused) return; // Don't search if not focused

    const timeoutId = setTimeout(() => {
      handleSearch(searchTerm);
    }, 300);

    return () => clearTimeout(timeoutId);
  }, [searchTerm, isSearchFocused]);

  const handleSearchBlur = (e) => {
    // Check if the related target is part of our search UI
    if (e.relatedTarget &&
      (e.relatedTarget.closest('.search-dropdown') ||
        e.relatedTarget.classList.contains('search-tab-button'))) {
      // If clicking within our search UI, don't hide
      return;
    }

    // Only hide if clicking outside our search UI
    setTimeout(() => {
      setIsSearchFocused(false);
    }, 200);
  };

  const handleResultClick = (result, category, e) => {
    // Prevent default behavior and stop propagation
    if (e) {
      e.preventDefault();
      e.stopPropagation();
    }

    

    if (category === 'user') {
      // Navigate to user profile
      setActiveTab("profile");
      history.push(`/profile/${result.id}`);
      // Close search after navigation
      setIsSearchFocused(false);
      setShowSearch(false);
    } else if (category === 'tag') {
      // Navigate to Portal with tag filter and set active tab
      setActiveTab("portal");

      // First store the selected filter in localStorage
      localStorage.setItem('selectedTabFilter', result.id);

      // Navigate to portal with the active tag in location state
      // This will ensure the tag is immediately loaded on portal page
      history.push('/portal', { activeTag: result.name });
      // Close search after navigation
      setIsSearchFocused(false);
      setShowSearch(false);
    } else if (category === 'opening') {
      // Navigate to Portal with opening filter
      setActiveTab("portal");
      
      // Create combined tag for the opening (Openings - [Opening Name])
      const openingTag = `Openings - ${result.name}`;
      
      // Navigate to portal with the opening information
      history.push('/portal', { 
        activeTag: 'OPENINGS',
        selectedOpening: result.name,
        isOpeningSelected: true 
      });
      
      // Close search after navigation
      setIsSearchFocused(false);
      setShowSearch(false);
    } else {
      setSearchTerm(result.name);
      // Don't close search when selecting other items
    }
  };

  // Check if we're on the ViewGame route
  const isViewGameRoute = () => {
    return location.pathname.startsWith('/games/');
  };

  // Check if we're on the Analysis route
  const isAnalysisRoute = () => {
    return location.pathname === '/Analysis';
  };

  // Check if we should show chess feature toggles (for both ViewGame and Analysis)
  const shouldShowChessToggles = () => {
    return isViewGameRoute() || isAnalysisRoute();
  };

  // Update the handler to toggle panel visibility instead of Stockfish
  const handleRobotClick = (e) => {
    // Prevent event from bubbling up to document
    e.stopPropagation();
    // Debug log
    setShowStockfishPanel(!showStockfishPanel);
  };

  // Reference to the control panel
  const panelRef = useRef(null);
  const robotRef = useRef(null);

  // Add click outside handler to close the control panel
  useEffect(() => {
    // Only add listener if panel is open
    if (showStockfishPanel) {
      const handleClickOutside = (event) => {
        // Close panel if click is outside panel and not on the robot button
        if (
          panelRef.current &&
          !panelRef.current.contains(event.target) &&
          robotRef.current &&
          !robotRef.current.contains(event.target)
        ) {
          setShowStockfishPanel(false);
        }
      };

      // Add event listener
      document.addEventListener('mousedown', handleClickOutside);

      // Clean up
      return () => {
        document.removeEventListener('mousedown', handleClickOutside);
      };
    }
  }, [showStockfishPanel, setShowStockfishPanel]);

  // Add new handlers for the individual buttons in the panel
  const handleStockfishToggle = () => {
    // Only allow toggling if not on Analysis page or if user is premium on ViewGame
    if (!isAnalysisRoute() && (premiumFeatures.stockfishAccess || !isViewGameRoute())) {
      setShowStockfish(!showStockfish);
    }
  };

  const handleStockfishEvalToggle = () => {
    setShowStockfishEval(!showStockfishEval);
  };

  // Determine robot color based on component states
  const getRobotColor = () => {
    // If Analysis page, where engine is always ON, the robot is always green
    if (isAnalysisRoute()) {
      return 'rgb(76, 175, 80)';
    }

    // For ViewGame, the robot color should be based on both EvalBar and Stockfish state
    // Green if either component is ON, red if both are OFF (regardless of premium status)
    if (isViewGameRoute()) {
      return (showStockfishEval || showStockfish) ? 'rgb(76, 175, 80)' : '#ff0050';
    }

    // Otherwise, green if either component is ON, red if both are OFF
    return (showStockfish || showStockfishEval) ? 'rgb(76, 175, 80)' : '#ff0050';
  };

  // Reset showStockfish when navigating between games
  useEffect(() => {
    // Reset stockfish when navigating to a new game
    if (isViewGameRoute()) {
      setShowStockfish(false);
    }

    // Close the panel when navigating
    setShowStockfishPanel(false);
  }, [location.pathname, setShowStockfish, setShowStockfishPanel]);

  // Handlers for the new toggle buttons
  const handleEmojiToggle = () => {
    setShowEmoji(!showEmoji);
  };

  const handleStockfishIconsToggle = () => {
    setShowStockfishIcons(!showStockfishIcons);
  };

  // Handler for the arrows toggle button
  const handleArrowsToggle = () => {
    setShowArrows(!showArrows);
  };

  // Calculate logo position adjustments based on sidebar state and if stockfish is showing
  const getLogoBottomPosition = () => {
    if (isCollapsed) {
      // When collapsed, adjust position based on how many chess feature buttons are showing
      return shouldShowChessToggles() ? '225px' : '225px';
    } else if (!isCollapsed) {
      // When expanded, use standard position
      return shouldShowChessToggles() ? '120px' : '120px';
    }
  };

  // Add a new function to close the search and ensure sidebar is properly expanded
  const handleCloseSearch = () => {
    setShowSearch(false);
    // Reset sidebar to fully expanded state
    setIsCollapsed(false);
    setIsSidebarCollapsed(false);
    localStorage.setItem('isSidebarCollapsed', 'false');
  };

  // Add a function to position tooltips dynamically
  const positionTooltip = (event, tooltipId) => {
    const tooltip = document.getElementById(tooltipId);
    if (!tooltip) return;

    // Get button position
    const rect = event.currentTarget.getBoundingClientRect();

    // Check if there's enough space to the right (at least 200px)
    const spaceToRight = window.innerWidth - rect.right;

    // Common offset for most buttons to ensure alignment
    const standardLeftOffset = 10;

    // Custom positioning based on tooltip ID
    let customLeftOffset = standardLeftOffset;

    // Special handling for Premium and Analyze buttons
    if (tooltipId === "tooltip-premium") {
      customLeftOffset = -6; // Fine-tune for Premium button with crown image
    }
    else if (tooltipId === "tooltip-analyze") {
      customLeftOffset = 23; // Fine-tune for Analyze button which has larger container
    }

    // Apply consistent styling to all tooltips
    tooltip.style.fontSize = '14px';
    tooltip.style.fontWeight = 'bold';

    if (spaceToRight >= 180) {
      // Position to the right if there's enough space
      tooltip.style.left = `${rect.right + customLeftOffset}px`;
      tooltip.style.top = `${rect.top + rect.height / 2}px`;
      tooltip.style.transform = 'translateY(-50%)';
    } else {
      // Position below if not enough space to the right
      tooltip.style.left = `${rect.left + rect.width / 2}px`;
      tooltip.style.top = `${rect.bottom + 10}px`;
      tooltip.style.transform = 'translateX(-50%)';
    }
  };

  // Add a function to switch between search tabs
  const handleSearchTabChange = (tab) => {
    setActiveSearchTab(tab);
    // Keep the search focused when switching tabs
    setIsSearchFocused(true);

    // Re-focus the search input
    if (searchInputRef.current) {
      searchInputRef.current.focus();
    }

    // If we haven't loaded data yet, load it now
    if (!initialSearchLoaded) {
      const loadInitialData = async () => {
        const followedUsers = await fetchFollowedUsers();
        
        // Get initial tags (first 5)
        const initialTags = Object.entries(TAGS).slice(0, 5).map(([key, tagData]) => ({
          id: key,
          name: tagData.label,
          color: tagData.color,
          background: tagData.background,
          className: tagData.className,
          sisterGroup: tagData.sisterGroup
        }));

        setSearchResults({
          users: [],
          followedUsers: followedUsers.slice(0, 10),
          tags: initialTags, // Show initial tags
          openings: dynamicOpenings.slice(0, 5)
        });

        setInitialSearchLoaded(true);
      };

      loadInitialData();
    } else if (tab === 'Chess') {
      // Make sure tags are loaded when switching to Chess tab
      const initialTags = Object.entries(TAGS).slice(0, 5).map(([key, tagData]) => ({
        id: key,
        name: tagData.label,
        color: tagData.color,
        background: tagData.background,
        className: tagData.className,
        sisterGroup: tagData.sisterGroup
      }));
      
      setSearchResults(prevResults => ({
        ...prevResults,
        tags: initialTags,
        openings: dynamicOpenings.slice(0, 5)
      }));
    }
  };

  // Add a function to determine if a button is active based on current route
  const isRouteActive = (buttonRoute) => {
    // Convert both paths to lowercase for case-insensitive comparison
    const currentPath = location.pathname.toLowerCase();

    // Check specific route matches
    switch (buttonRoute) {
      case "play":
        return currentPath.includes('/play') || currentPath.includes('/playchess');
      case "portal":
        return currentPath.includes('/portal');
      case "explore":
        return currentPath.includes('/explore');
      case "interaction":
        return currentPath.includes('/interaction');
      case "bookmark":
        return currentPath.includes('/bookmark');
      case "profile":
        return currentPath.includes('/profile');
      case "Premium":
        return currentPath.includes('/premium');
      case "AddGame":
        return currentPath.includes('/analysis') || currentPath.includes('/addgame');
      case "Settings":
        return currentPath.includes('/settings');
      default:
        return false;
    }
  };


  const toggleSidebar = () => {
    const newCollapsedState = !isCollapsed;
    setIsCollapsed(newCollapsedState);
    setIsSidebarCollapsed(newCollapsedState);
    localStorage.setItem('isSidebarCollapsed', JSON.stringify(newCollapsedState)); // Persist to local storage
  };

  // Determine if we should show the Stockfish button
  const shouldShowStockfishButton = () => {
    // Always show on Analysis page
    if (isAnalysisRoute()) {
      return true;
    }

    // Always show the robot on ViewGame page, regardless of premium status
    if (isViewGameRoute()) {
      return true;
    }

    // Don't show on other pages
    return false;
  };

  // Check if Stockfish button is currently showing
  const isStockfishShowing = () => {
    return (isViewGameRoute() || isAnalysisRoute());
  };

  // Check feedback rate limit (2 messages per 2 minutes)
  const checkFeedbackRateLimit = () => {
    const now = Date.now();
    const twoMinutes = 2 * 60 * 1000; // 2 minutes in milliseconds
    
    // Reset count if 2 minutes have passed
    if (now - feedbackRateLimit.lastReset > twoMinutes) {
      setFeedbackRateLimit({ count: 0, lastReset: now });
      return true;
    }
    
    // Check if user has exceeded the limit
    if (feedbackRateLimit.count >= 2) {
      const timeLeft = Math.ceil((twoMinutes - (now - feedbackRateLimit.lastReset)) / 1000 / 60);
      alert(`Please try again in a bit.`);
      return false;
    }
    
    return true;
  };

  // Handle feedback form submission (duplicated from PremiumPortal)
  const handleFeedbackSubmit = async () => {
    // Check rate limit first
    if (!checkFeedbackRateLimit()) {
      return;
    }

    // Now that Sidebar is connected to Redux, user data should be available in props
    const userHandle = props?.user?.credentials?.handle;
    const userEmail = props?.user?.credentials?.email;
    const userId = props?.user?.credentials?.userId;

    if (!userHandle || !userEmail || !userId) {
      alert("Could not identify user. Please ensure you are logged in.");
      return;
    }

    if (!feedbackMessage.trim()) {
      alert("Please enter your feedback before submitting.");
      return;
    }

    setIsSubmittingFeedback(true); // Disable button

    try {
      const feedbackCollectionRef = collection(firestore, 'feedback');
      await addDoc(feedbackCollectionRef, {
        userId: userId, // Add userId for security rules
        handle: userHandle,
        email: userEmail,
        message: feedbackMessage.trim(),
        createdAt: new Date().toISOString(),
      });

      // Update rate limit count after successful submission
      setFeedbackRateLimit(prev => ({
        ...prev,
        count: prev.count + 1
      }));

      alert("Thanks, your form has been submitted.");
      setFeedbackMessage(''); // Clear the message
      setShowFeedbackForm(false); // Hide the form

    } catch (error) {
      // console.error("Error submitting feedback: ", error);
      alert("Failed to submit feedback. Please try again.");
    } finally {
       setIsSubmittingFeedback(false); // Re-enable button
    }
  };

  return (
    <div className={`left-container left-container-3 ${isSidebarCollapsed ? 'collapsed' : 'expanded'}`} style={{
      width: sidebarWidth,
      transition: 'width 0.3s ease',
      overflowX: 'hidden' // Prevent horizontal scrolling
    }}>
      {/* Include the font style definition */}
      <MansalvaFontStyle />
      <GlobalScrollbarStyle />

      <div style={{ display: 'flex', flexDirection: 'column', gap: '10px', marginTop: '10px', marginLeft: isCollapsed ? '0px' : '15px' }}>
        {/* <button
          className="nav-button green-2-hover"
          onClick={() => handleTabChange("play")}
          onMouseEnter={(e) => isCollapsed && positionTooltip(e, "tooltip-play")}
          style={{
            textAlign: isCollapsed ? 'center' : 'left',
            position: 'relative',
            color: isRouteActive("play") ? '#58b047' : '' // Set active tab to white
          }}
        >
          <i className="fas fa-chess-board" style={{ width: '20px', color: isRouteActive("play") ? '#58b047' : '' }}></i>
          {!isCollapsed && <span>&nbsp;&nbsp;&nbsp;Play Chess</span>}
          {isCollapsed && <span id="tooltip-play" className="nav-tooltip">Play Chess</span>}
        </button> */}

        <button
          className="nav-button gold-2-hover"
          onClick={() => handleTabChange("portal")}
          onMouseEnter={(e) => isCollapsed && positionTooltip(e, "tooltip-portal")}
          style={{
            textAlign: isCollapsed ? 'center' : 'left',
            position: 'relative',
            color: isRouteActive("portal") ? 'gold' : '' // Set active tab to gold
          }}
        >
          <i style={{ width: '20px', color: isRouteActive("portal") ? 'gold' : '' }} className="fas fa-house"></i>
          {!isCollapsed && <span>&nbsp;&nbsp;&nbsp;Main Line</span>}
          {isCollapsed && <span id="tooltip-portal" className="nav-tooltip">Main Line</span>}
        </button>

        {/* <button
          className="nav-button"
          onClick={() => handleTabChange("explore")}
          onMouseEnter={(e) => isCollapsed && positionTooltip(e, "tooltip-explore")}
          style={{
            textAlign: isCollapsed ? 'center' : 'left',
            position: 'relative',
            color: isRouteActive("explore") ? 'gold' : '' // Set active tab to gold
          }}
        >
          <i style={{ width: '20px', color: isRouteActive("explore") ? 'gold' : '' }} className="fa-solid fa-chess-knight"></i>
          {!isCollapsed && <span>&nbsp;&nbsp;&nbsp;Explore</span>}
          {isCollapsed && <span id="tooltip-explore" className="nav-tooltip">Explore</span>}
        </button> */}

        <button
          className="nav-button"
          onClick={() => handleTabChange("interaction")}
          onMouseEnter={(e) => isCollapsed && positionTooltip(e, "tooltip-interaction")}
          style={{
            textAlign: isCollapsed ? 'center' : 'left',
            position: 'relative',
            color: isRouteActive("interaction") ? 'gold' : '' // Set active tab to gold
          }}
        >
          <div style={{ position: 'relative', display: 'inline-block' }}>
            <i style={{ width: '20px', color: isRouteActive("interaction") ? 'gold' : '' }} className="fa-solid fa-chess-pawn"></i>
            {hasUnreadNotifications && (
              <div
                style={{
                  position: 'absolute',
                  top: '-2px',

                  right: isCollapsed ? '-8px' : '-4px',
                  width: '8px',
                  height: '8px',
                  backgroundColor: '#58b047',
                  borderRadius: '50%',
                  border: '1px solid #58b047',
                  zIndex: 10
                }}
              ></div>
            )}
          </div>
          {!isCollapsed && <span>&nbsp;&nbsp;&nbsp;Interactions</span>}
          {isCollapsed && <span id="tooltip-interaction" className="nav-tooltip">Interactions</span>}
        </button>

        <button
          className="nav-button bookmark-button"
          id="sidebar-bookmark-button"
          onClick={() => handleTabChange("bookmark")}
          onMouseEnter={(e) => isCollapsed && positionTooltip(e, "tooltip-bookmark")}
          style={{
            textAlign: isCollapsed ? 'center' : 'left',
            position: 'relative',
            color: isRouteActive("bookmark") ? 'gold' : '' // Set active tab to gold
          }}
        >
          <i style={{ width: '20px', color: isRouteActive("bookmark") ? 'gold' : '' }} className="fa-solid fa-bookmark"></i>
          {!isCollapsed && <span>&nbsp;&nbsp;&nbsp;Bookmarks</span>}
          {isCollapsed && <span id="tooltip-bookmark" className="nav-tooltip">Bookmarks</span>}
        </button>

        <button
          className="nav-button"
          onClick={() => handleTabChange("profile")}
          onMouseEnter={(e) => isCollapsed && positionTooltip(e, "tooltip-profile")}
          style={{
            textAlign: isCollapsed ? 'center' : 'left',
            position: 'relative',
            color: isRouteActive("profile") ? 'gold' : '' // Set active tab to gold
          }}
        >
          <i style={{ width: '20px', color: isRouteActive("profile") ? 'gold' : '' }} className="fa-solid fa-chess-king"></i>
          {!isCollapsed && <span>&nbsp;&nbsp;&nbsp;My Profile</span>}
          {isCollapsed && <span id="tooltip-profile" className="nav-tooltip">My Profile</span>}
        </button>


        {/* TODO: Gold Crown Button for Premium */}
        {/* <button
          className="nav-button"
          onClick={() => handleTabChange("Premium")}
          onMouseEnter={(e) => {
            setIsHoveringCrown(true);
            isCollapsed && positionTooltip(e, "tooltip-premium");
          }}
          onMouseLeave={() => setIsHoveringCrown(false)}
          style={{
            textAlign: isCollapsed ? 'center' : 'left',
            display: 'flex',
            alignItems: 'center',
            justifyContent: '',
            marginLeft: isCollapsed ? '16px' : '-5px',
            position: 'relative',
            color: isRouteActive("Premium") ? 'gold' : '' // Set active tab to gold
          }}
        >
          <img src={isHoveringCrown || isRouteActive("Premium") ? GoldCrown : GrayCrown} style={{ width: '30px', height: '30px' }}></img>
          {!isCollapsed && <span style={{ color: isHoveringCrown ? 'gold' : isRouteActive("Premium") ? 'gold' : 'dimgray' }}>&nbsp;&nbsp;Premium</span>}
          {isCollapsed && <span id="tooltip-premium" className="nav-tooltip">Premium</span>}
        </button> */}
      </div>

      <button
        className={`nav-button pink-hover ${isCollapsed ? 'collapsed' : ''}`}
        onClick={() => handleTabChange("AddGameRoute")}
        onMouseEnter={(e) => isCollapsed && positionTooltip(e, "tooltip-analyze")}
        style={{
          minWidth: isCollapsed ? '50px' : '160px',
          width: isCollapsed ? '50px' : '160px',
          height: isCollapsed ? '60px' : '80px',
          color: isRouteActive("AddGame") ? 'gold' : '#3066be', // Change active color to gold
          borderRadius: '5px',
          border: isCollapsed ? '4px solid ' + (isRouteActive("AddGame") ? 'gold' : '#3066be') : '3px solid ' + (isRouteActive("AddGame") ? 'gold' : '#3066be'), // Change active border to gold
          fontSize: '20px',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          flexDirection: 'row',
          marginLeft: isCollapsed ? '12px' : '20px',
          gap: isCollapsed ? '0px' : '10px',
          fontWeight: 'bold',
          position: 'relative',
          transition: 'border-color 0.2s ease, color 0.2s ease'
        }}
      >
        <i className="fa-solid fa-square-plus" style={{ margin: isCollapsed ? '0' : '0', fontSize: isCollapsed ? '30px' : '40px', color: isRouteActive("AddGame") ? 'gold' : '', }}></i>
        <div style={{ lineHeight: '20px' }}>
          {!isCollapsed && <span>Analyze<br />& Share</span>}
        </div>
        {isCollapsed && <span id="tooltip-analyze" className="nav-tooltip" style={{ zIndex: 1000000 }}>Analyze & Share</span>}
      </button>

      {/* Feedback Button */}
      <button
        className="nav-button"
        onClick={() => setShowFeedbackForm(true)}
        onMouseEnter={(e) => isCollapsed && positionTooltip(e, "tooltip-feedback")}
        style={{
          textAlign: isCollapsed ? 'center' : 'left',
          position: 'relative',
          marginLeft: isCollapsed ? '12px' : '20px',
          marginTop: '5px',
          padding: isCollapsed ? '12px' : '12px 20px',
          backgroundColor: 'transparent',
          color: 'gray',
          // border: '2px solid gold',
          borderRadius: '8px',
          cursor: 'pointer',
          fontWeight: 'bold',
          fontSize: isCollapsed ? '16px' : '14px',
          transition: 'all 0.2s ease',
          width: isCollapsed ? '50px' : 'auto'
        }}
      >
        <i className="fa-solid fa-envelope" style={{ marginRight: isCollapsed ? '0' : '8px', color: '' }}></i>
        {!isCollapsed && <span>Give Feedback</span>}
        {isCollapsed && <span id="tooltip-feedback" className="nav-tooltip">Give Feedback</span>}
      </button>

      <div style={{ marginLeft: isCollapsed ? '8px' : '30px' }}>
        <Link to="/portal">
          <img
            src={ChesssLogo}
            alt="Chess Logo"
            style={{
              width: isCollapsed ? '60px' : '150px',
              height: 'auto',
              marginTop: '0px',
              position: 'absolute',
              bottom: getLogoBottomPosition(), // Use the dynamic position
              cursor: 'pointer'
            }}
            className="flush-bottom"
          />
        </Link>
      </div>
      {!isCollapsed && (
        <div
          style={{
            position: 'absolute',
            bottom: shouldShowChessToggles() ? '80px' : '80px',
            left: '40px',
            color: 'gold',
            fontSize: '20px',
            fontFamily: 'Mansalva, cursive',
          }}
        >ChessThread.com</div>
      )}

      {/* Add search overlay */}
      {showSearch && !isCollapsed && (
        <div
          className="custom-scrollbar"
          style={{
            position: 'absolute',
            top: '10px',
            left: '10px',
            width: '220px',
            bottom: '10px',
            backgroundColor: '#121212',
            borderRadius: '5px',
            border: '5px solid black',
            zIndex: 1000,
            padding: '20px',
            boxSizing: 'border-box',
            display: 'flex',
            flexDirection: 'column',
            gap: '20px',
            overflow: 'auto'
          }}
        >
          <div>
            <Link to="/portal">
              <img
                src={ChesssLogo}
                alt="Chess Logo"
                style={{
                  width: '180px',
                  height: 'auto',
                  marginTop: '0px',
                  cursor: 'pointer'
                }}
              />
            </Link>
          </div>

          <div style={{ position: 'absolute', right: '20px', bottom: '20px' }}>
            <button
              className="fen-buttons"
              onClick={handleCloseSearch}
              style={{
                color: 'gold',
                cursor: 'pointer',
                background: '#ff0050',
                padding: '20px 35px',
                fontWeight: 'bold',
                fontSize: '20px',
                borderRadius: '5px',
                border: '5px solid gold',
              }}>C L O S E
            </button> </div>

          {/* <div style={{ position: 'absolute', left: '', bottom: '100px' }}>
            <div style={{ width: '180px', background: '', padding: '', borderRadius: '5px', color: 'gold', fontSize: '24px', fontWeight: 'bold', marginBottom: '20px', paddingLeft: '10px' }}>Search <br /> For<br /> Anything . . .</div>
          </div> */}

          <div style={{ position: 'relative', display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center', color: 'gold', fontSize: '17px', fontWeight: 'bold' }}>
            <div style={{ borderTop: '3px solid gold', width: '160px', marginBottom: '30px' }}></div>
            <div style={{
              position: 'relative',
              display: 'flex',
              alignItems: 'center'
            }}>
              <input
                ref={searchInputRef}
                type="text"
                value={searchTerm}
                onChange={(e) => setSearchTerm(e.target.value)}
                onFocus={handleSearchInputClick}
                onBlur={handleSearchBlur}
                placeholder="Start Typing . . ."
                style={{
                  width: '100%',
                  padding: '10px',
                  paddingRight: '40px', // Make room for the icon
                  border: '2px solid gold',
                  borderRadius: '5px',
                  backgroundColor: 'transparent',
                  color: 'white',
                  fontSize: '16px',
                  outline: 'none'
                }}
              />
              <i
                className="fa-solid fa-magnifying-glass"
                style={{
                  position: 'absolute',
                  right: '12px',
                  color: 'gold',
                  fontSize: '18px',
                  pointerEvents: 'none' // Prevents the icon from interfering with input
                }}
              />
            </div>

            {/* Search results dropdown */}
            {isSearchFocused && (
              <div
                className="search-dropdown custom-scrollbar"
                style={{
                  position: 'absolute',
                  top: '100%',
                  width: '220px',
                  backgroundColor: '#222',
                  borderRadius: '0 0 10px 10px',
                  zIndex: 100,
                  maxHeight: '400px', // Limit the maximum height to ensure scrolling after 10 results
                  overflowY: 'auto',
                  boxShadow: '0 4px 8px rgba(0,0,0,0.3)',
                  marginTop: '5px'
                }}
              >
                {/* Search tabs */}
                <div style={{
                  display: 'flex',
                  borderBottom: '2px solid #333',
                  backgroundColor: '#1a1a1a',
                  position: 'sticky',
                  top: 0,
                  zIndex: 1
                }}>
                  <button
                    className="search-tab-button"
                    style={{
                      flex: 1,
                      padding: '10px',
                      backgroundColor: activeSearchTab === 'User' ? '#333' : 'transparent',
                      color: activeSearchTab === 'User' ? 'gold' : '#aaa',
                      border: 'none',
                      borderBottom: activeSearchTab === 'User' ? '2px solid gold' : 'none',
                      cursor: 'pointer',
                      fontWeight: activeSearchTab === 'User' ? 'bold' : 'bold'
                    }}
                    onClick={(e) => {
                      e.stopPropagation(); // Stop event propagation
                      e.preventDefault(); // Prevent default to avoid losing focus
                      handleSearchTabChange('User');
                    }}
                  >
                    USERS
                  </button>
                  <button
                    className="search-tab-button"
                    style={{
                      flex: 1,
                      padding: '10px',
                      backgroundColor: activeSearchTab === 'Chess' ? '#333' : 'transparent',
                      color: activeSearchTab === 'Chess' ? 'gold' : '#aaa',
                      border: 'none',
                      borderBottom: activeSearchTab === 'Chess' ? '2px solid gold' : 'none',
                      cursor: 'pointer',
                      fontWeight: activeSearchTab === 'Chess' ? 'bold' : 'bold'
                    }}
                    onClick={(e) => {
                      e.stopPropagation(); // Stop event propagation
                      e.preventDefault(); // Prevent default to avoid losing focus
                      handleSearchTabChange('Chess');
                    }}
                  >
                    CHESS
                  </button>
                </div>

                {isLoading ? (
                  <div style={{ padding: '15px', color: '#aaa', textAlign: 'center' }}>
                    <i className="fa fa-spinner fa-spin" style={{ marginRight: '8px' }}></i>
                    Loading...
                  </div>
                ) : (
                  <>
                    {/* USER TAB CONTENT */}
                    {activeSearchTab === 'User' && (
                      <>
                        {/* Followed Users section */}
                        {searchResults.followedUsers && searchResults.followedUsers.length > 0 && (
                          <div>

                            {searchResults.followedUsers.map(user => (
                              <div
                                key={user.id}
                                className="search-result-item"
                                style={{
                                  padding: '10px',
                                  cursor: 'pointer',
                                  borderBottom: '1px solid #333',
                                  display: 'flex',
                                  alignItems: 'center',
                                  paddingLeft: '15px'
                                }}
                                onClick={(e) => handleResultClick(user, 'user', e)}
                              >
                                {/* User profile picture with gold border for followed users */}
                                {/* <div style={{
                                  width: '24px',
                                  height: '24px',
                                  borderRadius: '50%',
                                  overflow: 'hidden',
                                  marginRight: '10px',
                                  backgroundColor: 'black',
                                  display: 'flex',
                                  alignItems: 'center',

                                  justifyContent: 'center',
                                  border: '2px solid gold', // Add gold border for followed users
                                  boxSizing: 'content-box', // Ensure the border is added outside of the div dimensions
                                  padding: '1px' // Small padding to make the border more visible
                                }}>

                                  <img
                                    src={user.imageUrl || "https://firebasestorage.googleapis.com/v0/b/chessisfun-66b29.firebasestorage.app/o/chessslogo.png?alt=media&token=6d387344-6b57-4aec-b04e-6e8b066c4edb"}
                                    alt={user.name || "Default profile"}
                                    onError={(e) => e.target.src = "https://firebasestorage.googleapis.com/v0/b/chessisfun-66b29.firebasestorage.app/o/chessslogo.png?alt=media&token=6d387344-6b57-4aec-b04e-6e8b066c4edb"}
                                    style={{
                                      width: '80%',
                                      height: '80%',
                                      objectFit: 'contain',
                                    }}
                                  />

                                </div> */}

                                {/* Render user with badge */}
                                {renderSearchResultUser(user)}

                              </div>
                            ))}
                          </div>
                        )}

                        {/* Other Users section */}
                        {searchResults.users && searchResults.users.length > 0 && (
                          <div>
                            {searchResults.users.map(user => (
                              <div
                                key={user.id}
                                className="search-result-item"
                                style={{
                                  padding: '10px',
                                  cursor: 'pointer',
                                  borderBottom: '1px solid #333',
                                  display: 'flex',
                                  alignItems: 'center',
                                  paddingLeft: '15px'
                                }}
                                onClick={(e) => handleResultClick(user, 'user', e)}
                              >
                                {/* Empty space to align with followed users */}
                                <div style={{ width: '', marginRight: '' }}></div>

                                {/* User profile picture */}
                                {/* <div style={{
                                  width: '24px',
                                  height: '24px',
                                  borderRadius: '50%',
                                  overflow: 'hidden',
                                  marginRight: '10px',
                                  backgroundColor: '#333',
                                  display: 'flex',
                                  alignItems: 'center',
                                  justifyContent: 'center',
                                  border: user.isFollowed ? '2px solid gold' : '2px solid #57b047', // Add gold border only if user is followed
                                  boxSizing: 'content-box', // Adjust box sizing based on border
                                  padding: '1px', // Add padding only if followed
                                }}>
                                  {user.imageUrl ? (
                                    <img
                                      src={user.imageUrl}
                                      alt={user.name}
                                      style={{
                                        width: '100%',
                                        height: '100%',
                                        objectFit: 'cover'
                                      }}
                                    />
                                  ) : (
                                    <img
                                      src="https://firebasestorage.googleapis.com/v0/b/chessisfun-66b29.firebasestorage.app/o/chessslogo.png?alt=media&token=6d387344-6b57-4aec-b04e-6e8b066c4edb"
                                      alt="Default profile"
                                      style={{
                                        width: '80%',
                                        height: '80%',
                                        objectFit: 'contain'
                                      }}
                                    />
                                  )}
                                </div> */}

                                {/* Render user with badge */}
                                {renderSearchResultUser(user)}
                              </div>
                            ))}
                          </div>
                        )}

                        {/* No results message for the entire search */}
                        {/* {searchTerm.trim() !== "" &&
                          searchResults.openings.length === 0 &&
                          searchResults.tags.length === 0 && (
                            <div style={{ padding: '15px', color: '#aaa', textAlign: 'center' }}>
                              No chess-related results found for "{searchTerm}"
                            </div>
                          )} */}

                        {/* Prompt to search when there are no followed users and no search term */}
                        {searchTerm.trim() === "" &&
                          searchResults.followedUsers.length === 0 && (
                            <div style={{ padding: '15px', color: '#aaa', textAlign: 'center' }}>
                              Search for users...
                            </div>
                          )}
                      </>
                    )}

                    {/* CHESS TAB CONTENT */}
                    {activeSearchTab === 'Chess' && (
                      <>
                        {/* Openings section */}
                        <div>
                          <div style={{
                            padding: '10px',
                            backgroundColor: '#333',
                            color: '#aaa',
                            fontSize: '18px',
                            display: 'flex',
                            alignItems: 'center',
                            paddingLeft: '20px'
                          }}>
                            <i className="fa-solid fa-chess-pawn" style={{ marginRight: '8px', color: '#57b047', fontSize: '18px' }}></i>
                            OPENINGS
                          </div>

                          {searchResults.openings.length > 0 ? (
                            searchResults.openings.map(opening => (
                              <div
                                key={opening.id}
                                className="search-result-item"
                                style={{
                                  padding: '10px',
                                  cursor: 'pointer',
                                  color: 'white',
                                  borderBottom: '1px solid #333',
                                  display: 'flex',
                                  alignItems: 'center',
                                  paddingLeft: '20px'
                                }}
                                onClick={(e) => handleResultClick(opening, 'opening', e)}
                              >
                            
                                <div>
                                  <div>{opening.name}</div>
                                 
                                </div>
                              </div>
                            ))
                          ) : (
                            <div style={{ padding: '10px', color: '#aaa', textAlign: 'center', fontSize: '12px' }}>
                              No openings match your search
                            </div>
                          )}
                        </div>

                        {/* Tags section - Always show this section regardless of search term */}
                        <div>
                          <div style={{
                            padding: '10px',
                            backgroundColor: '#333',
                            color: '#aaa',
                            fontSize: '18px',
                            display: 'flex',
                            alignItems: 'center',
                            paddingLeft: '20px'
                          }}>
                            <i className="fa-solid fa-chess-board" style={{ marginRight: '8px', color: '#57b047', fontSize: '18px' }}></i>
                            TAGS
                          </div>
                          
                          {searchResults.tags && searchResults.tags.length > 0 ? (
                            searchResults.tags.map(tag => (
                              <div
                                key={tag.id}
                                className="search-result-item"
                                style={{
                                  padding: '10px',
                                  cursor: 'pointer',
                                  borderBottom: '1px solid #333',
                                  display: 'flex',
                                  alignItems: 'center'
                                }}
                                onClick={(e) => handleResultClick(tag, 'tag', e)}
                                
                              >
                                <span style={{
                                  color: tag.background || '#888', // Use the background color as font color
                                  backgroundColor: 'transparent',
                                  fontWeight: 'bold',
                                  fontSize: '16px',
                                  paddingLeft: '10px'
                                }}>
                                  {tag.name}
                                </span>
                              </div>
                            ))
                          ) : (
                            <div style={{ padding: '10px', color: '#aaa', textAlign: 'center', fontSize: '12px' }}>
                              No tags match your search
                            </div>
                          )}
                        </div>

                        {/* No results message for the entire search */}
                        {/* {searchTerm.trim() !== "" &&
                          searchResults.openings.length === 0 &&
                          searchResults.tags.length === 0 && (
                            <div style={{ padding: '15px', color: '#aaa', textAlign: 'center' }}>
                              No chess-related results found for "{searchTerm}"
                            </div>
                          )} */}
                      </>
                    )}

                    {/* No results message for USER tab */}
                    {activeSearchTab === 'User' && 
                      searchTerm.trim() !== "" &&
                      searchResults.users.length === 0 &&
                      searchResults.followedUsers.length === 0 && (
                        <div style={{ padding: '15px', color: '#aaa', textAlign: 'center' }}>
                          No users found matching "{searchTerm}"
                        </div>
                      )}
                  </>
                )}
              </div>
            )}
          </div>
        </div>
      )}

      {/* Regular bottom icons */}
      <div style={{
        display: 'flex',
        flexDirection: isCollapsed ? 'column' : 'row',
        gap: isCollapsed ? '10px' : '15px', // Increase gap in collapsed mode
        position: 'absolute',
        bottom: shouldShowChessToggles() ? (isCollapsed ? '40px' : '40px') : '40px', // Increase space in collapsed mode
        left: isCollapsed ? '53px' : '120px',
        transform: 'translateX(-50%)',
        fontSize: '18px',
        color: 'gray',
        alignItems: 'center'
      }}>
        <div className="tooltip-container">
          <i
            className="fa-solid fa-arrows-left-right-to-line"
            style={{
              cursor: 'pointer',
              color: isCollapsed ? 'gold' : 'gray',
            }}
            onClick={toggleSidebar}
          ></i>
          <span className="tooltip">{isCollapsed ? "Expand" : "Collapse"}</span>
        </div>
        <div className="tooltip-container">
          <i
            className="fa-solid fa-right-from-bracket fa-rotate-180"
            onClick={handleLogout}
            style={{ cursor: 'pointer' }}
          ></i>
          <span className="tooltip">Logout</span>
        </div>
        <div className="tooltip-container">
          <i
            className="fa-solid fa-gear"
            style={{ cursor: 'pointer' }}
            onClick={() => handleTabChange("Settings")}
          ></i>
          <span className="tooltip">Settings</span>
        </div>
        <div className="tooltip-container">
          <i
            className="fa-solid fa-magnifying-glass"
            style={{ cursor: 'pointer' }}
            onClick={handleSearchIconClick}
          ></i>
          <span className="tooltip">Search</span>
        </div>
      </div>

      {/* Chess features toggle buttons - only show in ViewGame or Analysis routes */}
      {/* {shouldShowChessToggles() && (
        <div style={{
          display: 'flex',
          flexDirection: isCollapsed ? 'column' : 'row',
          gap: isCollapsed ? '10px' : '20px', // Increase gap in collapsed mode
          position: 'absolute',
          bottom: isCollapsed ? '45px' : '35px', // Increase bottom position in collapsed mode
          left: isCollapsed ? '57px' : '120px',
          transform: 'translateX(-50%)',
          fontSize: '18px',
          paddingTop: isCollapsed ? '0' : '15px',
          width: isCollapsed ? 'auto' : '',
          justifyContent: isCollapsed ? 'center' : 'space-between',
          alignItems: 'center',
        }}>

          <div className="tooltip-container" style={{ position: 'relative' }}>
            <i
              ref={robotRef}
              className="fa-solid fa-chess-board"
              style={{
                cursor: 'pointer',
                order: isCollapsed ? -1 : 0,
                color: getRobotColor(),
                boxShadow: '0 0 8px 2px rgba(255, 215, 0, 0.5)', // Gold glow effect
                borderRadius: '50%', // Rounded shape for better glow appearance
                padding: '5px',
                width: '30px',
                height: '30px',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                fontSize: '22px',
                marginRight: isSidebarCollapsed ? '8px' : '0px',
              }}
              onClick={handleRobotClick}
            ></i>
            {!showStockfishPanel && (
              <span className="tooltip" style={{ color: 'gold', fontWeight: 'bold', fontSize: '14px' }}>
                Game<br /> Controls
              </span>
            )}

            {showStockfishPanel && (
              <div
                ref={panelRef}
                style={{
                  position: 'absolute',
                  bottom: '35px',  // Position above the robot
                  left: '50%',     // Center relative to the robot
                  transform: 'translateX(-50%)', // Center horizontally
                  display: 'flex',
                  flexDirection: 'column',
                  gap: '8px',
                  backgroundColor: 'rgba(0, 0, 0, 0.9)', // Slightly darker background
                  padding: '10px',
                  borderRadius: '8px',
                  border: '1px solid #555',
                  zIndex: 100,
                  boxShadow: '0 0 15px rgba(0, 0, 0, 0.7)',
                  alignItems: 'center', // Center items
                  minWidth: '80px', // Slightly wider to accommodate multiple sections
                  maxWidth: '80px', // Fixed maximum width
                }}
              >
                <div style={{
                  color: 'gold',
                  fontWeight: 'bold',
                  fontSize: '14px',
                  marginBottom: '5px',
                  letterSpacing: '1px'
                }}>
                  ENGINE
                </div>

                <div style={{
                  width: '100%',
                  height: '1px',
                  backgroundColor: '#444',
                  marginBottom: '5px'
                }}></div>

                <div style={{
                  display: 'flex',
                  flexDirection: 'row',
                  gap: '15px',
                  justifyContent: 'center',
                  width: '100%',
                  marginBottom: '10px'
                }}>


                  <div
                    className="engine-panel-btn"
                    style={{
                      position: 'relative',
                      display: 'inline-block'
                    }}
                  >
                    <i
                      className="fa-solid fa-chart-simple fa-rotate-90"
                      style={{
                        cursor: 'pointer',
                        color: showStockfishEval ? 'rgb(76, 175, 80)' : '#f44336',
                        padding: '5px',
                        borderRadius: '50%',
                        boxShadow: '0 0 5px rgba(255, 215, 0, 0.3)',
                        fontSize: '18px'
                      }}
                      onClick={handleStockfishEvalToggle}
                    ></i>
                    <div className="engine-panel-tooltip">
                      {showStockfishEval ? 'Eval Bar' : 'Eval Bar'}
                    </div>
                  </div>
                  <div
                    className="engine-panel-btn"
                    style={{
                      position: 'relative',
                      display: 'inline-block'
                    }}
                  >
                    <i
                      className="fa-solid fa-robot"
                      style={{
                        cursor: isAnalysisRoute() ? 'default' : 'pointer',
                        color: isAnalysisRoute() ?
                          'rgb(76, 175, 80)' : // Always green in Analysis
                          isViewGameRoute() && !premiumFeatures.stockfishAccess ?
                            'gray' : // Gray for non-premium users in ViewGame
                            showStockfish ? 'rgb(76, 175, 80)' : '#f44336', // Green when ON, red when OFF
                        opacity: isAnalysisRoute() || (isViewGameRoute() && !premiumFeatures.stockfishAccess) ? 0.7 : 1,
                        padding: '5px',
                        borderRadius: '50%',
                        boxShadow: '0 0 5px rgba(255, 215, 0, 0.3)',
                        fontSize: '18px'
                      }}
                      onClick={isViewGameRoute() && !premiumFeatures.stockfishAccess ?
                        handlePremiumRequired :
                        isAnalysisRoute() ?
                          null :
                          handleStockfishToggle}
                    ></i>
                    <div className="engine-panel-tooltip">
                      {isViewGameRoute() && !premiumFeatures.stockfishAccess ?
                        'Analyze (Premium)' :
                        isAnalysisRoute() ?
                          'Stockfish' :
                          'Stockfish'}
                    </div>
                  </div>
                </div>

                <div style={{
                  color: 'gold',
                  fontWeight: 'bold',
                  fontSize: '14px',
                  marginBottom: '5px',
                  letterSpacing: '1px'
                }}>
                  VIEW
                </div>

                <div style={{
                  width: '100%',
                  height: '1px',
                  backgroundColor: '#444',
                  marginBottom: '5px'
                }}></div>

                <div style={{
                  display: 'flex',
                  flexDirection: 'row',
                  gap: '15px',
                  justifyContent: 'center',
                  width: '100%'
                }}>
                  <div
                    className="engine-panel-btn"
                    style={{
                      position: 'relative',
                      display: 'inline-block'
                    }}
                  >
                    <i
                      className="fa-solid fa-arrow-up"
                      style={{
                        cursor: 'pointer',
                        color: showArrows ? 'gold' : 'gray',
                        padding: '5px',
                        borderRadius: '50%',
                        boxShadow: '0 0 5px rgba(255, 215, 0, 0.3)',
                        fontSize: '18px'
                      }}
                      onClick={handleArrowsToggle}
                    ></i>
                    <div className="engine-panel-tooltip">
                      {showArrows ? 'Arrows' : 'Arrows'}
                    </div>
                  </div>

                  <div
                    className="engine-panel-btn"
                    style={{
                      position: 'relative',
                      display: 'inline-block'
                    }}
                  >
                    <div
                      onClick={handleStockfishIconsToggle}
                      style={{
                        cursor: 'pointer',
                        padding: '5px',
                        borderRadius: '50%',
                        boxShadow: '0 0 5px rgba(255, 215, 0, 0.3)',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                      }}
                    >
                      {showStockfishIcons ?
                        <img src={BlueBrilliantIcon} alt="Brilliant Icon" style={{ width: '18px', height: '18px' }} /> :
                        <img src={GrayBrilliantIcon} alt="Brilliant Icon" style={{ width: '18px', height: '18px' }} />}
                    </div>
                    <div className="engine-panel-tooltip">
                      {showStockfishIcons ? 'Brilliancies' : 'Brilliancies'}
                    </div>
                  </div>
                </div>
              </div>
            )}
          </div>
        </div>
      )} */}

      {/* Feedback Form Overlay */}
      {showFeedbackForm && (
        <div
          style={{
            position: 'fixed',
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            backgroundColor: 'rgba(0, 0, 0, 0.7)',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            zIndex: 2000
          }}
          onClick={() => setShowFeedbackForm(false)}
        >
          <div
            style={{
              backgroundColor: '#121212',
              padding: '30px',
              borderRadius: '8px',
              maxWidth: '500px',
              width: '90%',
              border: '2px solid gold',
              boxShadow: '0 5px 15px rgba(0, 0, 0, 0.5)',
              position: 'relative'
            }}
            onClick={(e) => e.stopPropagation()}
          >
            <i
              className="fa-solid fa-circle-xmark"
              style={{
                position: 'absolute',
                top: '15px',
                right: '15px',
                fontSize: '1.8rem',
                color: 'rgba(255, 255, 255, 0.7)',
                cursor: 'pointer',
                transition: 'color 0.2s ease'
              }}
              onClick={() => setShowFeedbackForm(false)}
              onMouseEnter={(e) => e.target.style.color = 'white'}
              onMouseLeave={(e) => e.target.style.color = 'rgba(255, 255, 255, 0.7)'}
            ></i>
            <h2 style={{
              fontSize: '24px',
              marginBottom: '25px',
              color: 'gold',
              textAlign: 'center',
              fontWeight: 'bold',
              paddingBottom: '10px',
              width: '100%'
            }}>
              Submit Feedback
            </h2>
            <textarea
              value={feedbackMessage}
              onChange={(e) => setFeedbackMessage(e.target.value)}
              placeholder="Enter your feedback here..."
              style={{
                width: '95%',
                height: '200px',
                padding: '10px',
                marginBottom: '30px',
                borderRadius: '6px',
                border: '1px solid rgba(255,215,0,0.5)',
                backgroundColor: 'rgba(0, 0, 0, 0.2)',
                color: 'white',
                fontSize: '1rem',
                resize: 'none',
                fontFamily: 'inherit'
              }}
            />
            <div style={{ display: 'flex', justifyContent: 'center', gap: '20px' }}>
              <button
                onClick={() => setShowFeedbackForm(false)}
                style={{
                  padding: '12px 25px',
                  backgroundColor: '#333',
                  color: 'white',
                  border: 'none',
                  borderRadius: '8px',
                  cursor: 'pointer',
                  fontWeight: 'bold',
                  fontSize: '1rem',
                  transition: 'all 0.2s ease'
                }}
              >
                Cancel
              </button>
              <button
                onClick={handleFeedbackSubmit}
                disabled={isSubmittingFeedback}
                style={{
                  backgroundColor: isSubmittingFeedback ? '#555' : 'gold',
                  color: 'black',
                  border: 'none',
                  padding: '12px 25px',
                  borderRadius: '8px',
                  cursor: isSubmittingFeedback ? 'not-allowed' : 'pointer',
                  fontWeight: 'bold',
                  fontSize: '1rem',
                  transition: 'all 0.2s ease',
                  opacity: isSubmittingFeedback ? 0.6 : 1,
                }}
              >
                {isSubmittingFeedback ? 'Submitting...' : 'Submit'}
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

const mapStateToProps = (state) => ({
  data: state.data,
  user: state.user,
});

export default connect(mapStateToProps)(Sidebar);
